<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol"   labelAlign="left" :model="form" :rules="rules">
      <a-collapse v-model="activeKey" @change="changeActivekey">
        <a-collapse-panel key="1" :header="$t('基础信息')" class="goods-collapse">
          <a-row >
            <a-col :span="24">
              <a-form-model-item  :label="$t('商品名称')" prop="goodsName" :label-col="{ span: 2 }" :wrapper-col="{ span: 20 }" >
                <a-input v-model="form.goodsName" :maxLength="128" :placeholder="$t('请输入')+$t('商品名称')">
                  <locale-field-button
                    slot="suffix"
                    class="ant-input-suffix-button"
                    v-model="form.localeFieldMap['goodsName']"
                    input-type="input"
                    table-name="goods_goods"
                    table-field="goodsName"
                    :field-value="form.goodsName"/>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="formType===2">
              <a-form-model-item  :label="$t('商品编号')" >
                <a-input disabled v-model="form.id" ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" >
              <a-form-model-item  :label="$t('商品编码')" >
                <a-input v-model="form.goodsCode" disabled
                         placeholder="保存后由系统自动生成，不支持手工录入"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="商城归属" prop="bizScope">
                <a-select v-model="form.bizScope" style="width: 100%" placeholder="请选择商城归属" allowClear @change="onBizScopeChange">
                  <a-select-option v-for="(item, index) in customDict.BizScopeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('平台商品分类')" prop="categoryIdList">
                <a-tree-select v-model="form.categoryIdList" style="width: 100%" multiple
                               :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="platformCategoryList" placeholder="请选择（最多5个）"
                               :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                               @change="onCategoryIdListChange">
                </a-tree-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('品牌')" prop="brandId">
                <a-select style="width: 100%" v-model="form.brandId" placeholder="请选择品牌" allowClear>
                  <a-select-option v-for="(item, index) in brandList" :value="item.id" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('包装单位')" prop="unit">
                <a-input v-model="form.unit" :maxLength="8" :placeholder="$t('请输入')+$t('包装单位')"/>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('系列')" prop="seriesId">
                <a-select style="width: 100%" v-model="form.seriesId" placeholder="请选择系列" allowClear :disabled="!form.brandId">
                  <a-select-option v-for="(item, index) in seriesList" :value="item.id" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="this.$t('商品主图')" prop="picture">
                <oss-upload-single :height="100" :width="100"  v-model="form.picture" prefix="goods" type="img"/>
                <span>推荐尺寸 375 x 375</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('商品视频')" prop="video">
                <oss-upload-single :height="100" :width="100" :max-size="500"  v-model="form.video" prefix="goods" type="video"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" >
              <a-form-model-item :label="$t('商品轮播图')" prop="pictureCarouselList" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" >
                <oss-upload-multi :is-array-data="true" :max-count="5" v-model="form.pictureCarouselList" prefix="goods" type="img"/>
                <span>推荐尺寸 375 x 375</span>
              </a-form-model-item>
            </a-col>
            <!--            <a-col :span="12">
                          <a-form-model-item  :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }" label="发货地" prop="shipAreaId">
                            <a-cascader :options="cityList"
                                        :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                                        :placeholder="$t('请选择')+'发货区域'"
                                        style="width: 100%" v-model="citySelected" allowClear @change="onCityChange">
                            </a-cascader>
                          </a-form-model-item>
                        </a-col>-->
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('快递模板')" prop="expressId">
                <a-button type="dashed" style="text-align: left; width: 100%" @click="openExpressSelect" danger>
                  <span style="color: dodgerblue">  {{this.getExpressName()}}</span>
                </a-button>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item  :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }" :label="$t('预计发货时间')" prop="deliveryTime">
                <a-input-number v-model="form.deliveryTime" :maxLength="8" :min="1" :max="100" :placeholder="$t('请输入')+$t('预计发货时间')"/>
                <span>(天) 内</span>
              </a-form-model-item>
            </a-col>
            <!--            <a-col :span="12">
                          <a-form-model-item prop="deliveryTimeDiscountList">
                            <span slot="label" >
                              <a-tooltip>
                                {{$t('发货时间折扣')}}
                                <template slot="title">期望发货时间折扣配置</template>
                              </a-tooltip>
                            </span>
                            <a-button type="dashed" style="text-align: left; width: 100%" @click="openTimeDiscount" danger>
                              <span style="color: dodgerblue">  {{this.getTimeDiscountName()}}</span>
                            </a-button>
                          </a-form-model-item>
                        </a-col>-->
          </a-row>
          <!--          <a-row>
                      <a-col :span="12">
                        <a-form-model-item prop="goodsCountDiscountList">
                          <span slot="label" >
                            <a-tooltip>
                              {{$t('购买数量折扣')}}
                            </a-tooltip>
                          </span>
                          <a-button type="dashed" style="text-align: left; width: 100%" @click="openGoodsCountDiscount" danger>
                            <span style="color: dodgerblue">  {{this.getGoodsCountDiscountName()}}</span>
                          </a-button>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="12">
                        <a-form-model-item prop="invoiceTaxList">
                          <span slot="label" >
                            <a-tooltip>
                              {{$t('发票税点配置')}}
                            </a-tooltip>
                          </span>
                          <a-button  v-model="form.invoiceTaxList" type="dashed" style="text-align: left; width: 100%" @click="openInvoiceTax" danger>
                            <span style="color: dodgerblue">  {{this.getInvoiceTaxName()}}</span>
                          </a-button>
                        </a-form-model-item>
                      </a-col>
                    </a-row>-->
          <a-row>
            <a-col :span="12">
              <a-form-model-item class="margin-bottom-10" :label="$t('是否限购')" prop="isMaxBuy">
                <a-radio-group v-model="form.isMaxBuy"  @change="maxBuyChange" button-style="solid">
                  <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item v-if="form.isMaxBuy" :label="$t('限购数')" prop="maxBuyNum">
                <a-input-number :maxLength="10" style="width: 45%" v-model="form.maxBuyNum" :max="1000000" oninput="value=value.replace(/[^\d]/g,'')"
                                :placeholder="$t('请输入')+$t('限购数')"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item  class="margin-bottom-10" :label="$t('是否推荐')" prop="isRecommend">
                <a-radio-group v-model="form.isRecommend"  button-style="solid">
                  <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item class="margin-bottom-10" :label="$t('是否新品')" prop="isNew">
                <a-radio-group v-model="form.isNew" button-style="solid">
                  <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item class="margin-bottom-10" :label="$t('是否展示')" prop="isShowApp">
                <a-radio-group v-model="form.isShowApp" button-style="solid">
                  <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <!--<a-col :span="12">
              <a-form-model-item class="margin-bottom-10" :label="$t('是否预售')" prop="isPresale">
                <a-radio-group v-model="form.isPresale" button-style="solid">
                  <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>-->
            <a-col :span="12">
              <a-form-model-item class="margin-bottom-10"  prop="isAutoOnSale">
                <span slot="label">
                  <a-tooltip>{{$t('是否自动上架')}}<template slot="title">商品审核通过后自动上架</template></a-tooltip>
                </span>
                <a-radio-group v-model="form.isAutoOnSale" button-style="solid">
                  <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="formType===2">
              <a-form-model-item class="margin-bottom-10" :label="$t('商品状态')" prop="status">
                <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="form.status" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
        <a-collapse-panel key="3" :header="$t('规格信息')"  class="goods-collapse">
          <a-alert type="info" show-icon class="margin-bottom-10" v-if= "bizScope===1"
                   message="平台商品只需填写规格名称（如颜色、尺寸）；规格值、售价、库存由商家报价时填写。不填规格也可以发布，商家将按整件商品报价。"/>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('划线价')" prop="marketPrice">
                <a-input v-model="form.marketPrice" @change="limitMarketPrice()" suffix="¥"
                         :placeholder="$t('请输入')+$t('商品售价')"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('虚拟销量')" prop="virtualSalesNum">
                <a-input v-model="form.virtualSalesNum" oninput="value=value.replace(/[^\d]/g,'')"
                         :placeholder="$t('请输入')+$t('虚拟销量')"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('是否展示销量')" prop="isShowSales">
                <a-radio-group button-style="solid" v-model="form.isShowSales">
                  <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="2">
              <a-button v-if="form.specList.length < 4" type="primary" style="width: 100%" @click="addSpec(1)"
                        class="margin-bottom">
                <a-icon type="plus"/>
                {{$t('添加规格')}}
              </a-button>
            </a-col>
            <a-col :span="20" >
            </a-col>
          </a-row>
          <div>
            <div class="box" v-for="(item, id) in form.specList" :key="id" >
              <a-row>
                <a-popconfirm  title="确定要删除此规格吗?" ok-text="确定" cancel-text="取消" @confirm="delSpec(id)">
                  <a-icon v-if="formType===1" type="close-circle" class="delSpec"/>
                </a-popconfirm>
                <a-col :span="8">
                  <a-form-model-item layout="inline" :label="$t('规格名称')" :prop="`specList.${id}.specName`" :rules='rules.specName'>
                    <a-input v-model="item.specName" :placeholder="$t('请输入')"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item layout="inline" :label="$t('规格描述')" :prop="`specList.${id}.specName`" :rules='rules.specDesc'>
                    <a-input v-model="item.specDesc" :placeholder="$t('请输入')"/>
                  </a-form-model-item>
                </a-col>
                <div class="margin-bottom-10" >
                  <a-button type="primary" @click='addSpecValue(item)'>
                    {{$t('添加规格值')}}
                  </a-button>
                </div>
              </a-row>

              <a-row>
                <a-col :span="20" >
                  <a-table :data-source="item.specValueList" :columns="specValueColumns" rowKey="id" :pagination="false"
                           bordered>
                    <div slot="specValueName" slot-scope="text, record">
                      <a-input v-model="record.specValueName" @change="specValueChange(item,record)" :maxLength="128" placeholder="请输入规格" @blur="validatorSpecValue(item)"/>
                    </div>
                    <template slot="specValuePicture" style="width: 50px;height: 50px" slot-scope="text, record">
                      <oss-upload-single :disabled="item.sort!==1" :height="50" :width="50"  @change="specValueChange(item,record)"  v-model="record.picture" prefix="goods" type="img"/>
                    </template>

                    <span slot="specValueSort" slot-scope="text, record">{{ record.sort }}</span>

                    <div slot="action" slot-scope="text, record, index" >
                      <a-tooltip title="上移">
                        <a-icon
                          type="arrow-up"
                          class="spec-value-sort-icon"
                          :class="{ 'spec-value-sort-icon--disabled': index === 0 }"
                          @click="index > 0 && moveSpecValueUp(item, index)"
                        />
                      </a-tooltip>
                      <a-tooltip title="下移">
                        <a-icon
                          type="arrow-down"
                          class="spec-value-sort-icon"
                          :class="{ 'spec-value-sort-icon--disabled': index === item.specValueList.length - 1 }"
                          @click="index < item.specValueList.length - 1 && moveSpecValueDown(item, index)"
                        />
                      </a-tooltip>
                      <a-popconfirm title="确定要删除此规格值吗？" ok-text="确定" cancel-text="取消" v-if="!record.isOrder && !record.notDelete"
                                    @confirm="delSpecValue(item,record)">
                        <a href="javascript:void(0)" style="color:red;margin-left: 8px;" >删除</a>
                      </a-popconfirm>
                    </div>
                  </a-table>
                  <span style="color: red;" v-if="item.specErrorMessage">{{ item.specErrorMessage }}</span>
                </a-col>
              </a-row>
            </div>
            <!--    sku列表        -->
            <div>
              <a-row v-if="this.formType===1">
                <a-col :span="20" :offset="2">
                  <a-button class='margin-tb' type="primary" @click="generateSkus" :disabled="this.formType===2">生成sku</a-button>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="20" :offset="2">
                  <div v-if="form.skuList && form.skuList.length" class="sku-batch-fill-wrap">
                    <div class="sku-batch-fill-bar">
                      <div class="sku-batch-fill-title">
                        <span>{{ $t('批量填充') }}</span>
                        <a-tooltip :title="$t('仅对下方 SKU 列表生效；只覆盖已填写的项')">
                          <a-icon type="info-circle" class="sku-batch-fill-info" />
                        </a-tooltip>
                      </div>
                      <div class="sku-batch-fill-fields">
                        <span class="sku-batch-fill-item">
                          <span class="sku-batch-fill-caption">{{ $t('价格') }}</span>
                          <a-input-number v-model="skuBatchFill.price" :max="9999999" :min="0" :step="0.01" size="small"  />
                        </span>
                        <span class="sku-batch-fill-item">
                          <span class="sku-batch-fill-caption">{{ $t('新品价') }}</span>
                          <a-input-number v-model="skuBatchFill.newPrice" :max="9999999" :min="0" :step="0.01" size="small"  />
                        </span>
                        <span class="sku-batch-fill-item">
                          <span class="sku-batch-fill-caption">{{ $t('成本价') }}</span>
                          <a-input-number v-model="skuBatchFill.costPrice" :max="9999999" :min="0" :step="0.01" size="small"  />
                        </span>
                        <span class="sku-batch-fill-item">
                          <span class="sku-batch-fill-caption">{{ $t('库存') }}</span>
                          <a-input-number v-model="skuBatchFill.stock" :max="999999999" :min="0" :step="1" size="small"  />
                        </span>
                        <span class="sku-batch-fill-item">
                          <span class="sku-batch-fill-caption">重量 (g)</span>
                          <a-input-number v-model="skuBatchFill.weight" :min="0" :max="999999999" :step="1" size="small"  />
                        </span>
                        <span class="sku-batch-fill-item">
                          <span class="sku-batch-fill-caption">体积 (m³)</span>
                          <a-input-number v-model="skuBatchFill.volume" :min="0" :max="999999999" :step="1" size="small" style="width: 110px" />
                        </span>
                        <a href="javascript:;" class="sku-batch-apply-link" @click="applySkuBatchFill">{{ $t('批量应用') }}</a>
                      </div>
                    </div>
                  </div>
                  <a-table :loading="skuLoading" :data-source="form.skuList" :columns="skuColumns" rowKey="id" :pagination="false" bordered class="sku-table-after-batch">
                    <div slot="skuPrice" slot-scope="text, record">
                      <a-input-number  v-model="record.price" :max="9999999" :min="0" :step="0.01" :placeholder="$t('请输入')+$t('商品价格')"  @blur.native.capture="validatorSku" />
                    </div>
                    <div slot="costPrice" slot-scope="text, record">
                      <a-input-number v-model="record.costPrice" :max="9999999" :min="0" :step="0.01" :placeholder="$t('请输入')+$t('成本价格')"  @blur.native.capture="validatorSku" />
                    </div>
                    <div slot="newPrice" slot-scope="text, record">
                      <a-input-number v-model="record.newPrice" :max="9999999" :min="0" :step="0.01" :placeholder="$t('请输入')+$t('新品价格')"  @blur.native.capture="validatorSku" />
                    </div>
                    <div slot="skuStockTitle">
                      {{$t('库存')}}
                      <a-tooltip>
                        <template slot="title">
                          <p>修改已经存在的sku的库存时,库存不会更新,有专门库存修改的地方</p>
                        </template>
                        <a-icon type="question-circle" />
                      </a-tooltip>
                    </div>
                    <div slot="skuCode" slot-scope="text, record">
                      <a-input v-model="record.skuCode" :placeholder="$t('请输入')+$t('SKU编码')" @blur.native.capture="validatorSku" />
                    </div>
                    <div slot="skuWeight" slot-scope="text, record">
                      <a-input-number v-model="record.weight" style="width: 100%" :min="0" :max="999999999" :step="1"  :placeholder="$t('请输入')+$t('商品重量')"  @blur.native.capture="validatorSku" />
                    </div>
                    <div slot="skuVolume" slot-scope="text, record">
                      <a-input-number v-model="record.volume"  style="width: 100%" :min="0" :max="999999999" :step="1"  :placeholder="$t('请输入')+'体积'"  @blur.native.capture="validatorSku" ></a-input-number>
                    </div>
                    <div slot="skuStock" slot-scope="text, record">
                      <a-input-number v-model="record.stock" :max="999999999" :placeholder="$t('请输入')+$t('商品库存')"  @blur.native.capture="validatorSku" />
                    </div>
                    <template slot="skuPicture" style="width: 50px;height: 50px" slot-scope="text, record">
                      <oss-upload-single :height="50" :width="50"  v-model="record.picture" prefix="goods" type="img"/>
                    </template>
                  </a-table>
                  <span style="color: red;" v-if="skuErrorMessage">{{ skuErrorMessage }}</span>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-collapse-panel>
        <a-collapse-panel key="4" :header="$t('商品详情')"   class="goods-collapse">
          <a-row style="height: 30px">
            <a-col></a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item :label-col="{span: 2}" :wrapper-col="{span: 20}"  :label="$t('商品详情')" prop="description">
                <editor ref="descriptionEditor" v-model="form.description" :placeholder="$t('请输入')+$t('商品详情')"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
        <!--        <a-collapse-panel key="5" header="品质说明"   class="goods-collapse">
                  <a-row style="height: 30px">
                    <a-col></a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item :label-col="{span: 2}" :wrapper-col="{span: 20}"  label="品质说明" prop="guarantee">
                        <editor ref="guaranteeEditor" :height="300" v-model="form.guarantee" placeholder="请输入品质说明"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-collapse-panel>-->
        </a-collapse-panel>
        <a-collapse-panel key="6" :header="$t('产品信息')" class="goods-collapse">
          <a-row style="height: 12px"><a-col></a-col></a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item :label-col="{span: 2}" :wrapper-col="{span: 20}" label="产品参数">
                <a-spin :spinning="paramTemplateLoading">
                  <div v-if="paramTemplateGroupList.length === 0" style="color:#999">
                    当前分类未配置属性模板，请在「商品分类 - 属性模板」中配置，也可在下方添加自定义参数
                  </div>
                  <div v-for="group in paramTemplateGroupList" :key="group.groupName">
                    <a-divider orientation="left" style="margin: 4px 0 12px 0;font-size:13px">{{ group.groupName }}</a-divider>
                    <a-row :gutter="16">
                      <a-col :span="8" v-for="item in group.paramList" :key="item.id" style="margin-bottom: 10px">
                        <div style="margin-bottom: 4px">
                          <span v-if="item.isRequire" style="color:#f5222d">* </span>{{ item.paramName }}
                          <span v-if="item.unit" style="color:#999">（{{ item.unit }}）</span>
                          <a-tag v-if="item.isInherited" color="orange" style="margin-left:4px">继承</a-tag>
                        </div>
                        <a-select v-if="item.inputType === 3" v-model="item.paramValue" style="width: 100%" allowClear placeholder="请选择">
                          <a-select-option v-for="opt in parseParamOptions(item.optionJson)" :value="opt" :key="opt">{{ opt }}</a-select-option>
                        </a-select>
                        <a-select v-else-if="item.inputType === 4" style="width: 100%" mode="multiple" allowClear placeholder="请选择"
                                  :value="item.paramValue ? item.paramValue.split(',') : []"
                                  @change="vals => item.paramValue = (vals || []).join(',')">
                          <a-select-option v-for="opt in parseParamOptions(item.optionJson)" :value="opt" :key="opt">{{ opt }}</a-select-option>
                        </a-select>
                        <a-input v-else v-model="item.paramValue" :maxLength="512" allowClear placeholder="请输入"/>
                      </a-col>
                    </a-row>
                  </div>
                </a-spin>
                <a-collapse :bordered="false" style="margin-top: 8px">
                  <a-collapse-panel key="customParam" header="自定义参数" style="background:#fafafa;border:0">
                    <a-table
                      :columns="paramColumns"
                      :data-source="customParamList"
                      :pagination="false"
                      :rowKey="(record, index) => index"
                      size="small">
                      <template slot="groupName" slot-scope="text, record">
                        <a-input v-model="record.groupName" :maxLength="64" placeholder="如：基础信息/外观设计/音源系统/键盘系统"/>
                      </template>
                      <template slot="paramName" slot-scope="text, record">
                        <a-input v-model="record.paramName" :maxLength="64" placeholder="如：品牌/材质/尺寸"/>
                      </template>
                      <template slot="paramValue" slot-scope="text, record">
                        <a-input v-model="record.paramValue" :maxLength="512" placeholder="如：雅马哈/云杉/40寸"/>
                      </template>
                      <template slot="sort" slot-scope="text, record">
                        <a-input-number v-model="record.sort" :min="0" style="width: 100%"/>
                      </template>
                      <template slot="action" slot-scope="text, record, index">
                        <a @click="removeGoodsParam(index)" style="color:#f5222d">删除</a>
                      </template>
                    </a-table>
                    <a-button type="dashed" style="margin-top: 8px;width: 100%" icon="plus" @click="addGoodsParam">添加自定义参数</a-button>
                  </a-collapse-panel>
                </a-collapse>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
        <a-collapse-panel key="5" header="温馨提示"   class="goods-collapse">
          <a-row style="height: 30px">
            <a-col></a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item :label-col="{span: 2}" :wrapper-col="{span: 20}"  label="温馨提示" prop="precautions">
                <editor ref="precautionsEditor" :height="300" v-model="form.precautions" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
      </a-collapse>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl"/>
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
    </a-form-model>
    <radio-freight-select-form ref="RadioFreightSelectForm" @freightSelect="indexFreightTemplateSelect"></radio-freight-select-form>
    <delivery-time-discount ref="DeliveryTimeDiscount" @timeDiscount="indexTimeDiscount"> </delivery-time-discount>
    <goods-count-discount ref="GoodsCountDiscount" @goodsCountDiscount="indexGoodsCountDiscount"> </goods-count-discount>
    <invoice-tax ref="invoiceTax" @invoiceTax="indexInvoiceTax"></invoice-tax>
  </a-drawer>
</template>

<script>
import {getMallGoods, addMallGoods, updateMallGoods} from '@/api/goods/goods'
import {platformCategoryTree, merchantCategoryTree, merchantIdCategoryTree} from "@/api/goods/category";
import {merchantBrand} from '@/api/goods/brand'
import {merchantSeries} from '@/api/goods/series'
import {paramTemplateByCategory} from '@/api/goods/paramTemplate'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import Editor from '@/components/Editor'
import DeliveryTimeDiscount from "@/views/goods/goods/modules/DeliveryTimeDiscount.vue";
import GoodsCountDiscount from "@/views/goods/goods/modules/GoodsCountDiscount.vue";
import OssUploadMulti from '@/components/OssUploadMulti/index.vue'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import RadioFreightSelectForm from '@/views/goods/shippingTemplate/modules/RadioSelectForm'
import {cityListTree} from "@/api/logistics";
import InvoiceTax from "@/views/goods/goods/modules/InvoiceTax.vue";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    LocaleFieldButton,
    InvoiceTax,
    Editor,
    OssUploadMulti,
    OssUploadSingle,
    RadioFreightSelectForm,
    GoodsCountDiscount,
    DeliveryTimeDiscount,
    CustomDictTag,
  },
  data() {
    return {
      tabIndex: 1,
      merchantCategoryList: [{id: "0", categoryName: '', children: []}],
      platformCategoryList :[],
      brandList: [],
      seriesList: [],
      labelList:[],
      cityList:[],
      /*是否有规格图片*/
      isSpecPic: false,
      /*分类的回显*/
      categorySelected: [],
      goodsTagInputList:[],
      paramColumns: [
        { title: '大项', dataIndex: 'groupName', width: '25%', scopedSlots: { customRender: 'groupName' } },
        { title: '参数名', dataIndex: 'paramName', width: '25%', scopedSlots: { customRender: 'paramName' } },
        { title: '参数值', dataIndex: 'paramValue', scopedSlots: { customRender: 'paramValue' } },
        { title: '排序', dataIndex: 'sort', width: '12%', scopedSlots: { customRender: 'sort' } },
        { title: '操作', dataIndex: 'action', width: '10%', scopedSlots: { customRender: 'action' } },
      ],
      // 分类属性模板(一级分组 + 二级属性值)
      paramTemplateGroupList: [],
      paramTemplateLoading: false,
      // 不属于任何模板的自定义参数
      customParamList: [],
      // 从服务端加载的已保存参数(用于回填属性值)
      savedParamList: [],
      labelCol: {span: 4},
      activeKey: [1, 2, 3, 4, 5,6],
      wrapperCol: {span: 16},
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      skuLoading: false,
      skuErrorMessage:undefined,
      errorMessage:undefined,
      /** 批量填充（独立数据，不参与 form.skuList） */
      skuBatchFill: {
        price: undefined,
        costPrice: undefined,
        newPrice: undefined,
        stock: undefined,
        weight: undefined,
        volume: undefined,
      },
      specValueColumns: [
        {
          title: this.$t('规格值'),
          dataIndex: 'specValueName',
          key: 'specValueName',
          scopedSlots: {customRender: 'specValueName'}
        },
        {
          title: this.$t('图片'),
          dataIndex: 'picture',
          key: 'specValuePicture',
          scopedSlots: {customRender: 'specValuePicture'}
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          slots: {title: 'addbtn', customRender: 'name'},
          scopedSlots: {customRender: 'action'}
        }
      ],
      skuColumns: [
        {
          title: this.$t('名称'),
          dataIndex: 'skuName',
          key: 'skuName',
        }, {
          title: this.$t('编码'),
          dataIndex: 'skuCode',
          key: 'skuCode',
          scopedSlots: {customRender: 'skuCode'}
        }, {
          title: this.$t('价格'),
          dataIndex: 'price',
          key: 'price',
          scopedSlots: {customRender: 'skuPrice'}
        }, {
          title: this.$t('新品价'),
          dataIndex: 'newPrice',
          key: 'newPrice',
          scopedSlots: {customRender: 'newPrice'}
        },{
          title: this.$t('成本价'),
          dataIndex: 'costPrice',
          key: 'costPrice',
          scopedSlots: {customRender: 'costPrice'}
        },
        {
          dataIndex: 'stock',
          slots: { title: 'skuStockTitle' },
          key: 'stock',
          scopedSlots: {customRender: 'skuStock'}
        }, {
          title: '重量 (g)',
          dataIndex: 'weight',
          key: 'weight',
          scopedSlots: {customRender: 'skuWeight'}
        }, {
          title: '体积 (m³)',
          dataIndex: 'volume',
          key: 'volume',
          scopedSlots: {customRender: 'skuVolume'}
        }, {
          title: this.$t('图片'),
          dataIndex: 'picture',
          key: 'picture',
          scopedSlots: {customRender: 'skuPicture'}
        }
      ],
      // 表单参数
      form: {
        id: null,
        isMaxBuy: false,
        specList: [],
        skuList: [],
        goodsCode: undefined,
        goodsTagList: [],
        maxBuyNum: null,
        onSaleTime: null,
        pictureCarouselList: [],
        expressDetail: null,
        logisticsDetail: null,
        goodsName: null,
        goodsType: 20,
        bizScope: undefined,
        weight: null,
        unit: null,
        picture: null,
        deliveryTime :1,
        deliveryTimeDiscountList : [],
        goodsCountDiscountList : [],
        invoiceTaxList:[],
        color: null,
        video: null,
        pictureList: null,
        merchantId: null,
        categoryIdList: [],
        merchantCategoryId: null,
        brandId: null,
        seriesId: null,
        price: null,
        marketPrice: null,
        virtualSalesNum: 0,
        expressId: null,
        logisticsId: null,
        stock: null,
        description: null,
        precautions: null,
        shippingMode: null,
        guarantee: null,
        isRecommend: false,
        isNew: false,
        isShowSales: false,
        isShowApp: true,
        isAutoOnSale: true,
        sort: null,
        parameter: null,
        localeFieldMap: {},
        paramList: [],
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goodsName: [{required: true, message: this.$t('商品名称') + this.$t('不能为空'), trigger: 'blur'}],
        goodsType: [{required: true, message: this.$t('商品类型') + this.$t('不能为空'), trigger: 'blur'}],
        bizScope: [{required: true, message: '商城归属' + this.$t('不能为空'), trigger: 'change'}],
        specName: [{required: true, message: this.$t('规格.规格名称') + this.$t('不能为空'), trigger: 'blur'}],
        isMaxBuy: [{required: true, message: this.$t('是否限购') + this.$t('不能为空'), trigger: 'blur'}],
        maxBuyNum: [{required: true, message: this.$t('限购数') + this.$t('不能为空'), trigger: 'blur'}],
        weight: [{required: true, message: this.$t('商品重量') + this.$t('不能为空'), trigger: 'blur'}],
        unit: [{required: false, message: '包装单位'+ this.$t('不能为空'), trigger: 'blur'}],
        picture: [{required: true, message: this.$t('商品主图') + this.$t('不能为空'), trigger: 'blur'}],
        deliveryTime: [{required: true, message: '预计发货时间' + this.$t('不能为空'), trigger: 'blur'}],
        brandId: [{required: false, message: '商品品牌' + this.$t('不能为空'), trigger: 'change'}],
        status: [{required: false, message: '商品状态' + this.$t('不能为空'), trigger: 'change'}],
        categoryIdList: [
          {required: true, message: '平台商品分类' + this.$t('不能为空'), trigger: 'change'},
          {type: 'array', max: 5, message: '平台商品分类最多只能选5个', trigger: 'change'}
        ],
        merchantCategoryId: [{required: false, message: '商家商品分类' + this.$t('不能为空'), trigger: 'change'}],
        price: [{required: true, message: this.$t('商品价格') + this.$t('不能为空'), trigger: 'blur'}],
        costPrice: [{required: true, message: this.$t('成本价格') + this.$t('不能为空'), trigger: 'blur'}],
        onSaleTime: [{required: true, message: this.$t('上架时间') + this.$t('不能为空'), trigger: 'change'}],
        marketPrice: [{required: true, message: '划线价' + this.$t('不能为空'), trigger: 'blur'}],
        virtualSalesNum: [{required: true, message: this.$t('虚拟销量') + this.$t('不能为空'), trigger: 'blur'}],
        expressId: [{required: true, message: '快递模板' + this.$t('不能为空'), trigger: 'change'}],
        logisticsId: [{required: false, message: '物流模板' + this.$t('不能为空'), trigger: 'change'}],
        stock: [{required: true, message: this.$t('商品库存') + this.$t('不能为空'), trigger: 'blur'}],
        isRecommend: [{required: true, message: this.$t('是否推荐') + this.$t('不能为空'), trigger: 'blur'}],
        isNew: [{required: true, message: this.$t('是否新品') + this.$t('不能为空'), trigger: 'blur'}],
        isShowApp: [{required: true, message: '是否在app上显示' + this.$t('不能为空'), trigger: 'blur'}],
        isAutoOnSale: [{required: true, message: '是否自动上架' + this.$t('不能为空'), trigger: 'blur'}],
        isShowSales: [{required: true, message: this.$t('是否展示销量') + this.$t('不能为空'), trigger: 'blur'}],
        sort: [{required: true, message: this.$t('排序') + this.$t('不能为空'), trigger: 'blur'}],
      }
    };
  },
  filters: {},
  created() {
    this.getPlatformCategoryList()
    this.getBrandList()
    this.getCityTree()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    'form.brandId'(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== oldVal) {
        this.form.seriesId = undefined
      }
      this.getSeriesList(newVal)
    }
  },
  mounted() {
  },
  methods: {
    back() {
    },
    /*锚点*/
    getCurrentAnchor() {
      return '#components-anchor-demo-static';
    },
    getCityTree() {
      cityListTree().then(response => {
        this.cityList = response.data
      })
    },
    changeTab(index, type) {
      if (type === 'next') {
        let isValid = false
        this.$refs.form.validate(valid => {
          isValid = valid;
        });
        if (!isValid) {
          console.log('有必填项未填');
          return
        }
        this.tabIndex = index + 1;
      } else if (type === 'back') {
        this.tabIndex = index - 1
      }
    },
    resetSkuBatchFill() {
      this.skuBatchFill = {
        price: undefined,
        costPrice: undefined,
        newPrice: undefined,
        stock: undefined,
        weight: undefined,
        volume: undefined,
      };
    },
    shouldApplySkuBatchField(val) {
      return val !== undefined && val !== null && val !== '';
    },
    applySkuBatchFill() {
      if (!this.form.skuList || this.form.skuList.length === 0) {
        this.$message.warning(this.$t('暂无 SKU'));
        return;
      }
      const b = this.skuBatchFill;
      let hasInput = false;
      if (this.shouldApplySkuBatchField(b.price) || this.shouldApplySkuBatchField(b.costPrice) || this.shouldApplySkuBatchField(b.newPrice) ||
        this.shouldApplySkuBatchField(b.stock) || this.shouldApplySkuBatchField(b.weight) ||
        this.shouldApplySkuBatchField(b.volume)) {
        hasInput = true;
      }
      if (!hasInput) {
        this.$message.warning(this.$t('请至少填写一项要填充的值'));
        return;
      }
      this.form.skuList.forEach(sku => {
        if (this.shouldApplySkuBatchField(b.price)) {
          sku.price = Number(b.price);
        }
        if (this.shouldApplySkuBatchField(b.costPrice)) {
          sku.costPrice = Number(b.costPrice);
        }
        if (this.shouldApplySkuBatchField(b.newPrice)) {
          sku.newPrice = Number(b.newPrice);
        }
        if (this.shouldApplySkuBatchField(b.stock)) {
          sku.stock = Number(b.stock);
        }
        if (this.shouldApplySkuBatchField(b.weight)) {
          sku.weight = Number(b.weight);
        }
        if (this.shouldApplySkuBatchField(b.volume)) {
          sku.volume = Number(b.volume);
        }
      });
      this.$message.success(this.$t('已批量应用'));
      this.validatorSku();
    },
    generateSkus() {
      this.skuLoading = true;
      this.form.skuList = [];
      let  skuValueList = [];
      //拿到所有的sku值
      this.form.specList.forEach(spec => {
        skuValueList.push(spec.specValueList);
      });
      //递归,求笛卡尔积
      let sku = this.cartesianProduct(skuValueList);
      //把这些sku 组装一下放到skuList里
      let skuList = [];
      let index = 1;
      sku.forEach(e => {
        let name = '';
        let skuPic = this.form.picture;
        let specValueIds = '';
        e.forEach(j => {
          name += j.specValueName + "  ";
          specValueIds += j.id + ":";
        });
        specValueIds = specValueIds.substring(0, specValueIds.length - 1);
        const newData = {
          id: index,
          skuName: name,
          skuCode: null,
          costPrice: 0,
          newPrice: this.form.marketPrice,
          price: this.form.marketPrice,
          picture: skuPic,
          specValueIds: specValueIds,
          isNew :true,
          isOrder :false,
          stock: 99999,
          weight: 100,
          volume: 100
        };
        skuList.push(newData);
        index++;
      });
      this.form.skuList = skuList;
      this.resetSkuBatchFill();
      this.skuLoading = false;
    },

    cartesianProduct(arr) {
      if (arr.length === 0) {
        return [[]];
      }
      const result = [];
      const rest = this.cartesianProduct(arr.slice(1));
      for (let i = 0; i < arr[0].length; i++) {
        for (let j = 0; j < rest.length; j++) {
          result.push([arr[0][i], ...rest[j]]);
        }
      }
      return result;
    },
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },

    /*分类的选择*/
    onCategoryChange(value, selectedOptions) {
      this.form.merchantCategoryId = value[1]
    },

    onCategoryIdListChange(value) {
      //乐器(12位)与配件(13位)商品都用所选分类的品类编码生成商品编码，只能对应一个品类
      const needSingleCategory = this.form.bizScope === 1 || this.form.bizScope === 3
      if (needSingleCategory && value && value.length > 1) {
        const scopeTip = this.form.bizScope === 3 ? '配件' : '乐器'
        this.$nextTick(() => {
          this.form.categoryIdList = value.slice(0, 1)
          this.$message.warning(scopeTip + '商品只能选择一个平台商品分类')
        })
      } else if (value && value.length > 5) {
        this.$nextTick(() => {
          this.form.categoryIdList = value.slice(0, 5)
          this.$message.warning('平台商品分类最多只能选5个')
        })
      }
      this.loadParamTemplate()
    },

    openExpressSelect () {
      this.$refs.RadioFreightSelectForm.openList(this.form.expressId,1);
    },
    openLogisticsSelect () {
      this.$refs.RadioFreightSelectForm.openList(this.form.logisticsId,2);
    },
    indexFreightTemplateSelect(record, logisticsType) {
      if (logisticsType === 1) {
        this.form.expressId = record.id;
        this.form.expressDetail = record;
      } else if (logisticsType === 2) {
        this.form.logisticsId = record.id;
        this.form.logisticsDetail = record;
      }
    },
    getExpressName() {
      if (this.form.expressId && this.form.expressDetail) {
        return this.form.expressDetail.name
      } else {
        return this.$t('请选择')+'快递模板'
      }
    },
    getLogisticsName() {
      if (this.form.logisticsId && this.form.logisticsDetail) {
        return this.form.logisticsDetail.name
      } else {
        return this.$t('请选择')+'物流模板'
      }
    },
    clearLogisticsId () {
      this.form.logisticsId = 0
      this.form.logisticsDetail = undefined
      console.log('清除了物流模板',this.form.logisticsDetail)
    },
    openTimeDiscount () {
      this.$refs.DeliveryTimeDiscount.show(this.form.deliveryTimeDiscountList);
    },
    indexTimeDiscount(list) {
      this.form.deliveryTimeDiscountList = list
      this.getTimeDiscountName()
    },

    getTimeDiscountName() {
      if (this.form.deliveryTimeDiscountList && this.form.deliveryTimeDiscountList.length>0) {
        let str = ''
        this.form.deliveryTimeDiscountList.forEach(e=>{
          str += e.day + '天内' + e.discount + '折,   '
        })
        return str
      } else {
        return '配置发货时间折扣'
      }
    },

    openGoodsCountDiscount () {
      this.$refs.GoodsCountDiscount.show(this.form.goodsCountDiscountList);
    },
    indexGoodsCountDiscount(list) {
      this.form.goodsCountDiscountList = list
      this.getGoodsCountDiscountName()
    },
    getGoodsCountDiscountName() {
      if (this.form.goodsCountDiscountList && this.form.goodsCountDiscountList.length>0) {
        let str = ''
        this.form.goodsCountDiscountList.forEach(e=>{
          str += e.goodsCount + '件内' + e.discount + '折,   '
        })
        return str
      } else {
        return '配置商品数量折扣'
      }
    },
    openInvoiceTax() {
      this.$refs.invoiceTax.show(this.form.invoiceTaxList);
    },
    indexInvoiceTax(list) {
      this.form.invoiceTaxList = list
      this.getInvoiceTaxName()
    },
    getInvoiceTaxName() {
      if (this.form.invoiceTaxList && this.form.invoiceTaxList.length>0) {
        let str = ''
        this.form.invoiceTaxList.forEach(e=>{
          str += e.invoiceName + ': ' + e.tax +",";
        })
        return str.length > 40 ? str.substring(0, 40) + '...' : str
      } else {
        return '配置发票税点'
      }
    },


    // 表单重置
    reset() {
      this.formType = 1
      this.categorySelected= [];
      this.activeKey = [1,2,3,4,5]
      this.form = {
        id: null,
        goodsCode: undefined,
        isMaxBuy: false,
        specList: [],
        skuList: [],
        goodsTagList: [],
        maxBuyNum: null,
        onSaleTime: null,
        pictureCarouselList: [],
        expressDetail: null,
        logisticsDetail: null,
        goodsName: null,
        goodsType: 20,
        bizScope: undefined,
        weight: null,
        unit: null,
        picture: null,
        video: null,
        pictureList: null,
        categoryIdList: [],
        deliveryTime :1,
        deliveryTimeDiscountList : [],
        goodsCountDiscountList : [],
        invoiceTaxList:[],
        merchantCategoryId: null,
        brandId: undefined,
        seriesId: undefined,
        price: null,
        marketPrice: null,
        virtualSalesNum: 0,
        expressId: null,
        logisticsId: null,
        stock: null,
        description: null,
        precautions: null,
        shippingMode: null,
        guarantee: null,
        isRecommend: false,
        isNew: false,
        isShowSales: false,
        isShowApp: true,
        isAutoOnSale: true,
        sort: null,
        parameter: null,
        localeFieldMap: {},
        paramList: [],
      };
      this.savedParamList = [];
      this.paramTemplateGroupList = [];
      this.customParamList = [];
      this.resetSkuBatchFill();
    },

    addGoodsParam() {
      if (!Array.isArray(this.customParamList)) {
        this.$set(this, 'customParamList', [])
      }
      this.customParamList.push({ groupName: '', paramName: '', paramValue: '', sort: this.customParamList.length })
    },
    removeGoodsParam(index) {
      this.customParamList.splice(index, 1)
    },

    // 解析单选/多选的候选值
    parseParamOptions(optionJson) {
      if (!optionJson) {
        return []
      }
      try {
        const arr = JSON.parse(optionJson)
        return Array.isArray(arr) ? arr : []
      } catch (e) {
        return []
      }
    },

    /**
     * 按已选的平台商品分类加载属性模板，并把已保存的参数值回填到对应属性上
     * 模板内不存在的参数归入自定义参数
     */
    loadParamTemplate() {
      const categoryIdList = this.form.categoryIdList || []
      if (categoryIdList.length === 0) {
        this.paramTemplateGroupList = []
        this.customParamList = this.savedParamList.slice()
        return
      }
      this.paramTemplateLoading = true
      paramTemplateByCategory({ categoryIdList: categoryIdList }).then(response => {
        const groupList = response.data || []
        const savedMap = {}
        this.savedParamList.forEach(p => {
          savedMap[(p.groupName || '') + '\u0001' + (p.paramName || '')] = p.paramValue
        })
        const matchedKeySet = {}
        this.paramTemplateGroupList = groupList.map(group => ({
          groupName: group.groupName,
          paramList: (group.paramList || []).map(template => {
            const key = (template.groupName || '') + '\u0001' + (template.paramName || '')
            matchedKeySet[key] = true
            return Object.assign({}, template, { paramValue: savedMap[key] || '' })
          })
        }))
        this.customParamList = this.savedParamList.filter(p => {
          const key = (p.groupName || '') + '\u0001' + (p.paramName || '')
          return !matchedKeySet[key]
        })
      }).finally(() => {
        this.paramTemplateLoading = false
      })
    },

    /**
     * 组装提交用的参数列表：模板属性(只保留填了值的) + 自定义参数
     */
    buildParamList() {
      const paramList = []
      this.paramTemplateGroupList.forEach(group => {
        group.paramList.forEach(item => {
          const paramValue = item.paramValue == null ? '' : String(item.paramValue).trim()
          if (paramValue) {
            paramList.push({
              templateId: item.id,
              groupName: group.groupName,
              groupSort: item.groupSort,
              paramName: item.paramName,
              paramValue: paramValue,
              sort: item.sort
            })
          }
        })
      })
      this.customParamList
        .filter(p => (p.paramName && p.paramName.trim()) || (p.paramValue && p.paramValue.trim()))
        .forEach((p, i) => {
          paramList.push({
            groupName: (p.groupName || '').trim(),
            paramName: (p.paramName || '').trim(),
            paramValue: (p.paramValue || '').trim(),
            sort: p.sort == null ? i : p.sort
          })
        })
      return paramList
    },

    // 校验分类属性模板中的必填项
    validateParamTemplate() {
      for (let i = 0; i < this.paramTemplateGroupList.length; i++) {
        const group = this.paramTemplateGroupList[i]
        for (let j = 0; j < group.paramList.length; j++) {
          const item = group.paramList[j]
          if (item.isRequire && !(item.paramValue && String(item.paramValue).trim())) {
            this.$message.warning('请填写' + group.groupName + ' - ' + item.paramName)
            return false
          }
        }
      }
      return true
    },

    limitMarketPrice() {
      // console.log(i);
      let val = this.form.marketPrice.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val<0) {
        val = 0
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.marketPrice = val
    },

    maxBuyChange() {
      if (!this.form.isMaxBuy) {
        this.form.maxBuyNum = 0;
      }
    },

    validatorSku() {
      if (!this.form.skuList) {
        return true;
      }
      let message = "";
      this.form.skuList.forEach(e=>{
        let skuErrorMessage = "";
        if (e.price<=0) {
          skuErrorMessage +=this.$t('价格') + this.$t('不能小于0')+"; ";
        }
        if (e.stock<0) {
          skuErrorMessage +=this.$t('库存') + this.$t('不能小于0')+"; ";
        }
        if (e.weight<=0) {
          skuErrorMessage +=this.$t('重量') + this.$t('不能小于0')+"; ";
        }
        message=skuErrorMessage
      })
      if (message) {
        this.skuErrorMessage = message;
        return false;
      }
      this.skuErrorMessage = '';
      return true;
    },

    validatorSpecValue(item) {
      let specErrorMessage = "";
      item.specValueList.forEach(e=>{
        if (!e.specValueName) {
          specErrorMessage += this.$t('规格值') + this.$t('不能为空');
        }
      })
      if (specErrorMessage) {
        item.specErrorMessage = specErrorMessage;
        return false;
      }
      item.specErrorMessage= undefined;
      return true;
    },
    validatorSpecValueAll() {
      let result = true;
      this.form.specList.forEach(spec=>{
        let specErrorMessage = "";
        spec.specValueList.forEach(e=>{
          if (!e.specValueName) {
            specErrorMessage += this.$t('规格值') + this.$t('不能为空');
          }
        })
        if (specErrorMessage) {
          spec.specErrorMessage = specErrorMessage;
          result = false;
        } else {
          spec.specErrorMessage = undefined;
        }
      })

      return result;
    },

    /*页面初始化时获取分类类别*/
    getMerchantCategoryList(merchantId) {
      if (merchantId) {
        merchantIdCategoryTree({"merchantId":merchantId}).then(response => {
          this.merchantCategoryList = response.data
        });
      } else {
        merchantCategoryTree({}).then(response => {
          this.merchantCategoryList = response.data
        })
      }
    },

    getPlatformCategoryList(bizScope) {
      platformCategoryTree({ bizScope: bizScope }).then(response => {
        this.platformCategoryList = this.markLeafOnly(response.data)
      })
    },

    /** 商城归属变化：分类只展示该归属下的分类，已选分类自动清空 */
    onBizScopeChange(bizScope) {
      this.form.categoryIdList = []
      this.loadParamTemplate()
      this.getPlatformCategoryList(bizScope)
      this.applyCodeRuleByBizScope(bizScope)
    },

    /** 乐器/配件商品要用品类编码+品牌编码生成商品编码，因此品牌必填、分类只能选一个 */
    applyCodeRuleByBizScope(bizScope) {
      const needGoodsCode = bizScope === 1 || bizScope === 3
      this.rules.brandId = [{required: needGoodsCode, message: '商品品牌' + this.$t('不能为空'), trigger: 'change'}]
      this.rules.categoryIdList = [
        {required: true, message: '平台商品分类' + this.$t('不能为空'), trigger: 'change'},
        {type: 'array', max: needGoodsCode ? 1 : 5, message: needGoodsCode ? '商品只能选择1个平台商品分类' : '平台商品分类最多只能选5个', trigger: 'change'}
      ]
    },

    // 商品只能挂在末级分类（该分类下不能再有子分类），其余节点置灰不可选
    markLeafOnly(treeData) {
      (treeData || []).forEach(item => {
        if (item.children && item.children.length > 0) {
          item.disabled = true
          this.markLeafOnly(item.children)
        }
      })
      return treeData
    },



    getBrandList() {
      merchantBrand({}).then(response => {
        this.brandList = response.data
      })
    },

    getSeriesList(brandId) {
      if (!brandId) {
        this.seriesList = []
        return
      }
      merchantSeries({brandId: brandId}).then(response => {
        this.seriesList = response.data
      })
    },

    addSpec() {
      let validatorSpec = this.validatorSpecValueAll();
      if (!validatorSpec) {
        return;
      }
      const index = this.form.specList.length + 1;
      const newData = {
        id: index,
        specName: null,
        specDesc: null,
        isNew : true,
        isHaveImg: false,
        sort: index,
        specValueList: [],
      };
      this.form.specList.push(newData);
    },
    editSpec() {
      //修改规格后,清空所有sku
      this.form.skuList = [];
    },
    delSpec(id) {
      if (this.formType === 1) {
        this.form.specList.splice(id, 1)
        this.generateSkus();
        if (this.form.specList.length===0) {
          this.form.skuList = []
        }
      } else {
        /*let delSpecValueIdList = []
        this.form.specList.forEach(e => {
          if (e.id === id) {
            e.specValueIds.forEach(id=>{
              delSpecValueIdList.push(id);
            })
          }
        });
        //删除sku里的
        let sku = []
        this.form.skuList.forEach(e => {
          let valueIdList = e.specValueIds.split(":");
          //删除
          delSpecValueIdList.forEach(delSpecValueId => {
            let cateInfo = valueIdList.find(valueId => valueId === delSpecValueId);
            if (cateInfo) {

            } else {
              sku.push(e)
            }
          })
        });
        this.form.skuList = sku*/
      }
    },

    addSpecValue(item) {
      let validatorSpecValue = this.validatorSpecValueAll();
      if (!validatorSpecValue) {
        return;
      }
      //这个地方有个小bug,specValueList 用户可能会减一下,加一下,会造成index 重复,因此,取最后一个的id + 1
      let index = Number(item.id %100000 * 100) + item.specValueList.length + 1;
      //判断index在  item.specValueList 里是否重复, 如果重复,使用最后一个的id + 1
      let isRepeat = false;
      item.specValueList.forEach(e => {
        if (e.id === index.toString()) {
          isRepeat = true;
        }
      });
      if (isRepeat) {
        index = Number(item.specValueList[item.specValueList.length - 1].index) + 1;
        console.log('重新生成index',index)
      }
      const newData = {
        index: index.toString(),
        id: index.toString(),
        specValueName: null,
        specName: item.specName,
        isNew: true,
        isOrder :false,
        specErrorMessage:undefined,
        sort: item.specValueList.length + 1,
      };
      if (item.sort === 1) {
        newData.picture = this.form.picture
      }
      //新sku ,第一个不能删
      if (item.isNew && item.specValueList.length===0) {
        newData.notDelete = true;
      }
      item.specValueList.push(newData);
      this.normalizeSpecValueSortOrder(item);
      //如果是新的规格添加新的规格值.需要修改sku
      if (item.isNew && item.specValueList.length===1) {
        let skuList = [];
        if (this.form.skuList.length===0) {
          this.generateSkus()
        } else {
          this.form.skuList.forEach(e => {
            e.specValueIds = e.specValueIds + ":"+index
            skuList.push(e)
          });
          this.form.skuList = skuList
        }
      } else {
        //如果是修改页面的增加规格值, 则在sku 里也新增1* 其他规格值的信息
        let specList = [];
        //拿到所有的sku值
        this.form.specList.forEach(spec => {
          if (spec.id === item.id) {
            let newDataList = []
            newDataList.push(newData)
            specList.push(newDataList);
          } else {
            specList.push(spec.specValueList);
          }
        });
        //递归,求笛卡尔积
        let sku = this.cartesianProduct(specList);
        //把这些sku 组装一下放到skuList里
        let index = 1;
        sku.forEach(e => {
          let name = '';
          let skuPic = '';
          let specValueIds = '';
          e.forEach(j => {
            name += j.specValueName + "  ";
            specValueIds += j.id + ":";
            if (j.picture) {
              skuPic = j.picture
            }
          });
          specValueIds = specValueIds.substring(0, specValueIds.length - 1);
          const newData = {
            id: index.toString(),
            skuName: name,
            skuCode: null,
            price: this.form.marketPrice,
            costPrice: 0,
            newPrice: this.form.marketPrice,
            picture: skuPic,
            isNew: true,
            specValueIds: specValueIds,
            stock: 99999,
            weight: 100,
            volume: 100,
          };
          this.form.skuList.push(newData);
          index++;
        });
      }
    },
    delSpecValue(item, record) {
      item.specValueList = item.specValueList.filter(e => e.id !== record.id);
      let skuList = [];
      this.form.skuList.forEach(e => {
        let valueIdList = e.specValueIds.split(":");
        let cateInfo = valueIdList.find(e => e === record.id);
        if (cateInfo) {
          console.log('删除specValueId',record.id,'的sku ')
        } else {
          skuList.push(e)
        }
      });
      this.form.skuList = skuList
      this.normalizeSpecValueSortOrder(item);
    },

    /** 规格值列表顺序号（1 起），与数组顺序一致 */
    normalizeSpecValueSortOrder(item) {
      if (!item || !item.specValueList) {
        return
      }
      item.specValueList.forEach((e, i) => {
        e.sort = i + 1
      })
      if (item.specValueList.length===1) {
        item.specValueList.forEach(e=>{
          e.notDelete = true
        })
      }
    },

    moveSpecValueUp(item, index) {
      if (index <= 0) {
        return
      }
      const list = item.specValueList
      const row = list.splice(index, 1)[0]
      list.splice(index - 1, 0, row)
      this.normalizeSpecValueSortOrder(item)
    },

    moveSpecValueDown(item, index) {
      const list = item.specValueList
      if (index >= list.length - 1) {
        return
      }
      const row = list.splice(index, 1)[0]
      list.splice(index + 1, 0, row)
      this.normalizeSpecValueSortOrder(item)
    },

    specValueChange: function (spec,record) {
      let skuValueList = [];
      //拿到所有的sku值
      this.form.specList.forEach(spec => {
        spec.specValueList.forEach(specValue=>{
          skuValueList.push(specValue);
        })
      });
      //自动修改sku 里对应的规格名称
      //sku 里原本就有数据,修改sku 名字
      this.form.skuList.forEach(e => {
        let valueIdList = e.specValueIds.split(":");
        let name = ""
        valueIdList.forEach(specValueId => {
          if (record.id === specValueId) {
            name = name + record.specValueName + "  ";
            if (spec.sort === 1) {
              e.picture = record.picture;
            }
          } else {
            const specValue =skuValueList.find(item => item.id === specValueId);
            if (specValue) {
              name = name + specValue.specValueName + "  "
            }
          }
        });
        e.skuName = name
      });
    },

    /** 新增按钮操作（bizScope：从商城商品子菜单进入时锁定该商城归属） */
    handleAdd(bizScope) {
      this.reset()
      this.open = true
      this.formType = 1
      this.formTitle = this.$t('添加')
      this.getPlatformCategoryList(bizScope)
      this.getMerchantCategoryList()
      if (bizScope !== undefined) {
        this.form.bizScope = bizScope
        this.applyCodeRuleByBizScope(bizScope)
      }
    },
    /** 修改按钮操作 */
    handleUpdate(id, copy) {
      this.reset()
      this.formType = 2
      getMallGoods({"id": id}).then(response => {
        this.form = response.data
        // 分类树必须按该商品的商城归属加载，否则已选分类不在树中、只回显 id
        this.getPlatformCategoryList(this.form.bizScope)
        this.applyCodeRuleByBizScope(this.form.bizScope)
        if (!Array.isArray(this.form.paramList)) {
          this.$set(this.form, 'paramList', [])
        }
        this.savedParamList = this.form.paramList.slice()
        this.loadParamTemplate()
        if (this.form.specList && this.form.specList.length) {
          this.form.specList.forEach(spec => {
            this.normalizeSpecValueSortOrder(spec)
          })
        }
        //规格已存在但SKU未生成（如平台自营配件发布时未生成SKU），按现有规格补生成，否则无法维护售价与库存
        if (!copy && (!this.form.skuList || this.form.skuList.length === 0)
          && this.form.specList && this.form.specList.length) {
          this.generateSkus()
          this.form.skuList.forEach(e => {
            e.isNew = true
          })
        }
        this.categorySelected = response.data.merchantCategoryIdList
        this.getMerchantCategoryList(response.data.merchantId)
        if (copy) {
          this.formTitle = this.$t('复制');
          this.formType = 1
          this.form.id = null
          this.form.goodsName = this.form.goodsName+"(复制)"
          this.form.status=0
          this.form.pictureCarouselList = [];
          this.form.onSaleTime = null
          let oldSkuList = this.form.skuList
          this.generateSkus()
          //按照名称进行匹配,将oldSkuList里的价格赋值到form.skuList里去
          oldSkuList.forEach(e => {
            this.form.skuList.forEach(sku => {
              //skuName trim 匹配
              if (sku.skuName.trim() === e.skuName.trim()) {
                sku.price = e.price
                sku.costPrice = e.costPrice
                sku.newPrice = e.newPrice
                sku.weight = e.weight
                sku.volume = e.volume
                sku.stock = e.stock
                sku.skuCode = e.skuCode
              }
            });
          });
          this.form.skuList.forEach(e=>{
            e.isNew = true
          })
          this.form.specList.forEach(e => {
            e.isNew =true
            e.specValueList.forEach(value => {
              value.isNew =true
              value.isOrder =false
            })
          });
        } else {
          this.formTitle = this.$t('修改');
        }
        this.open = true
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    changeActivekey(key) {
      return
    },


    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        let skuValid = this.validatorSku();
        if (!skuValid) {
          return false;
        }
        if (valid) {
          if (!this.validateParamTemplate()) {
            return false;
          }
          this.submitLoading = true;
          this.form.paramList = this.buildParamList()
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMallGoods(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(this.$t('修改成功'), 3);
                this.open = false
                this.$emit('ok')
                this.back();
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMallGoods(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(this.$t('新增成功'), 3)
                this.open = false
                this.$emit('ok')
                this.back();
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false;
        }
      });
    }
  }
}
</script>
<style lang="less" >
.goods-collapse > .ant-collapse-header {
  color: #007ffd !important;
  background: #e8eef9;
}
.box {
  position: relative;
  background-color: #f7f7f7;
  padding: 0 15px 15px 15px;
  margin-bottom: 15px;
  border-radius: 5px;

  .delSpec {
    position: absolute;
    right: -5px;
    top: -5px;
    color: #f5222d;
    cursor: pointer;
  }
}


.spec-value-sort-icon {
  cursor: pointer;
  margin-right: 8px;
  color: #1890ff;
  font-size: 16px;
  vertical-align: middle;
}
.spec-value-sort-icon--disabled {
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}

.sku-batch-fill-wrap {
  margin-bottom: -1px;

}
.sku-batch-fill-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 0px;
  gap: 12px 16px;
  padding: 10px 12px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
}
.sku-batch-fill-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  flex-shrink: 0;
}
.sku-batch-fill-info {
  margin-left: 6px;
  color: #999;
  cursor: help;
}
.sku-batch-fill-fields {
  display: flex;
  flex-wrap: wrap;
  text-align: right;
  align-items: center;
  gap: 10px 14px;
  flex: 1;
}
.sku-batch-fill-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.sku-batch-fill-caption {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  white-space: nowrap;
}
.sku-batch-apply-link {
  color: #1890ff;
  margin-left: 4px;
  white-space: nowrap;
  padding-top: 4px;
}
.sku-table-after-batch {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

</style>
